export default "__VITE_ASSET__4yzHafPX__"